import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { MultipleNeutral2 as Svg } from './svgs/MultipleNeutral2.svg';

export const MultipleNeutral2 = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
